export default __webpack_public_path__ + "static/media/i135sp.23eb8b8a.webp";